/**
 * Created by AB74296 on 9/5/2017.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { HashRouter, Route } from 'react-router-dom';
import BlockUi from 'react-block-ui';	
import 'react-block-ui/style.css';
import { Header } from '../components/index';
import commonStore from '../stores/commonStore';
import PreparerInfo from '../../QualityOfCare/Preparer-Information/PreparerInfo';
import MemberInfo from '../../QualityOfCare/Member-Information/MemberInfo';
import PractionerLocation from '../../QualityOfCare/Practitioner-Location/PracLocation';
import IncidentDetails from '../../QualityOfCare/Incident-Details/IncidentDetails';
import ReviewSubmit from '../../QualityOfCare/Review-Submit/ReviewSubmit';
import ScrollToTop from '../utilities/scroll';
import ConfirmationScreen from '../../QualityOfCare/Confirmation/Confirmation';
import qualityStore from '../../QualityOfCare/stores/QualityStore';

@observer
class Layout extends Component {
  renderRootPath = () => {
    return (
      <div>
        <Route exact path="/" component={PreparerInfo} />
        <Route exact path="/memberinfo" component={MemberInfo} />
        <Route exact path="/practitionerlocation" component={PractionerLocation} />
        <Route exact path="/incidentdetails" component={IncidentDetails} />
        <Route exact path="/reviewsubmit" component={ReviewSubmit} />
        <Route exact path="/confirmation" component={ConfirmationScreen} />
        <Route exact path="/preparerinfo" component={PreparerInfo} />
      </div>
    );
  };

  render() {
    return (
      <div className="container">
        <Header commonStore={commonStore} />
        <HashRouter basename="/">
          <BlockUi tag="div" blocking={qualityStore.blocking}>
            <ScrollToTop />
            <Route path="/" render={this.renderRootPath} />
          </BlockUi>
        </HashRouter>
      </div>
    );
  }
}

export default Layout;